<template>
  <div class="mobileDocDetail">
    <div class="browser_warp" @click="maskShow=false" v-show="maskShow">
      <div class="browser_bg"></div>
      <div class="open_browser_tips">
        <img src="/static/img/link_c.png">
      </div>
    </div>
    <header class="title">
      <i class="el-icon-arrow-left"></i>
      <span>
          新闻
      </span>
    </header>
    <main>
      <div class="mainBox">
        <div class="detailTitle">
          <h1>{{newsTitle}}</h1>
          <div class="titieFooter">
            <p>{{newsCreateTime}}</p>
            <p>
              <i><img src="/static/mobileImg/supportSmall.png" alt=""></i>
              <span>{{praiseCount}}</span>
              <i><img src="/static/mobileImg/discuss.png" alt=""></i>
              <span>{{commentCount}}</span>
            </p>
          </div>
        </div>
        <div class="detailMessage">
          <div class="messageContents" v-html="decodeURIComponent(newsContent)">
            {{decodeURIComponent(newsContent)}}
          </div>
          <p class="readCounts">
            阅读数：<span>{{readNumber}}</span>
          </p>
        </div>
        <div style="height:0.15rem;background:#eee;"></div>
        <div class="commentBox">
          <div class="commentTitle"><span>评论</span> </div>
          <div class="commentMessage">
            <div class="commentDetail" v-for="item in commentDataList" :key="item.id">
              <div class="imgBox"><img :src="item.userAvatarURL" alt="显示失败"></div>
              <div class="rightBox">
                <div class="userBox">
                  <p class="userName">
                    <span>{{item.userNickname}}</span>
                    <span>评论课程：</span>
                  </p>
                  <p class="commenNumber">
                    <span>{{item.praiseCount}}</span>
                    <i><img src="/static/mobileImg/supportSimple.png" alt=""></i>
                  </p>
                </div>
                <div class="userMessage">{{item.content}}</div>
                <div class="commentTime">
                  <span>{{item.createTime}}</span>
                  <span @click="handleShowSecond">回复</span>
                </div>
                <div class="secondComment" v-show="isShowSecond" v-for="secondItem in item.commentVos" :key="secondItem.id">
                  <div class="secondCommentMessage">
                    <div class="commentDetail">
                      <div class="imgBox"><img :src="secondItem.userAvatarURL" alt=""></div>
                      <div class="rightBox">
                        <div class="userBox">
                          <p class="userName">
                            <span>{{secondItem.userNickname}}</span>
                            <span>评论课程：</span>
                          </p>
                          <p class="commenNumber">
                            <span>{{secondItem.praiseCount}}</span>
                            <i><img src="/static/mobileImg/supportSimple.png" alt=""></i>
                          </p>
                        </div>
                        <div class="userMessage">{{secondItem.content}}</div>
                        <div class="secondCommentTime">
                          <span>{{secondItem.createTime}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width:100%;height:1px;background:#eeeeee;float:left;"></div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <footer @click.stop="jump">
      <div class="commendInput">我要回复...</div>
      <div class="fx" style="margin-right: 0.63rem;">
        <img src="/static/mobileImg/supportBig.png" alt="">
        <p>点赞</p>
      </div>
      <div class="fx" style="margin-right: 0.65rem;">
        <img src="/static/mobileImg/weChat.png" alt="">
        <p>微信</p>
      </div>
      <div class="fx">
        <img src="/static/mobileImg/sina.png" alt="">
        <p>微博</p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data () {
    return {
      maskShow: false,
      isShowSecond: false,
      newsTitle: null,
      newsCreateTime: null,
      praiseCount: null,
      commentCount: null,
      newsContent: null,
      readNumber: null,
      commentDataList: []
    }
  },
  computed: {
    newsId () {
      return this.$route.query.id
    }
  },
  watch: {
    newsId (val) {
      if (val) {
        this.getNewsData()
        this.getCommentData()
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.getNewsData()
    this.getCommentData()
  },
  methods: {
    init () {
      let isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      if (!isWx) {
        let { isAndroid, isIOS, isIOS9 } = this.detectVersion()
        var ifr = document.createElement('iframe')
        ifr.setAttribute('style', 'display:none')
        if (isAndroid) {
          ifr.setAttribute('src', `${window.SITE_CONFIG['androidUrl']}`)
        } else if (isIOS || isIOS9) {
          ifr.setAttribute('src', `${window.SITE_CONFIG['iosAppUrl']}`)
        }
        document.body.appendChild(ifr)
      }
    },
    // 获取评论详情
    getCommentData () {
      this.$http.get(`${window.SITE_CONFIG['trainURL']}/courseManagement/traincomment/listNewsCommentsAtDetailPage`, {
        params: {
          page: 1,
          limit: 3,
          id: this.newsId
        }
      }).then(data => {
        this.commentDataList = data.result.data.data
      })
    },
    // 获取新闻详情
    getNewsData () {
      this.$http.post(`${window.SITE_CONFIG['trainURL']}/news/trainnewstrain/infoWithComment`, {
        id: this.newsId
      }).then(data => {
        this.newsTitle = data.result.data.title
        this.newsCreateTime = data.result.data.createTime
        this.praiseCount = data.result.data.praiseCount
        this.commentCount = data.result.data.commentCount
        this.newsContent = data.result.data.content
        this.readNumber = data.result.data.clickNum
      })
    },
    handleShowSecond () {
      this.isShowSecond = !this.isShowSecond
    },
    jumpDownload () {
      let { isAndroid, isIOS, isIOS9 } = this.detectVersion()
      if (isAndroid) {
        window.location = window.SITE_CONFIG['androidUrl']
      } else if (isIOS || isIOS9) {
        window.location = window.SITE_CONFIG['iosUrl']
      }
    },
    jump () {
      let isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      if (isWx) {
        this.maskShow = true
      } else {
        // this.openApp('', this.jumpDownload)
        this.jumpDownload()
      }
    },
    detectVersion () {
      let isAndroid = false
      let isIOS = false
      let isIOS9
      let version
      let u = navigator.userAgent
      let ua = u.toLowerCase()
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // android终端或者uc浏览器
        // Android系统
        isAndroid = true
      }
      if (ua.indexOf('like mac os x') > 0) {
        // ios
        // let regStr_saf = /os [\d._]*/gi ;
        let verinfo = ua.match(/os [\d._]*/gi)
        version = (verinfo + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
      }
      let versionStr = version + ''
      if (versionStr !== 'undefined' && versionStr.length > 0) {
        version = parseInt(version)
        if (version >= 8) {
          // ios9以上
          isIOS9 = true
        } else {
          isIOS = true
        }
      }
      return { isAndroid, isIOS, isIOS9 }
    }
  }
}
</script>
<style scoped>
  .browser_warp {
    display: block;
  }
  .browser_bg {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #000;
    opacity: 0.8;
    z-index: 999;
  }
  .open_browser_tips {
    position: fixed;
    width: 100%;
    top: 0;
    right: 0;
    z-index: 9999;
  }
  .open_browser_tips img {
    width: 100%;
    border: 0;
    margin: 0;
    padding: 0;
  }
  .fx{
    width: 0.43rem;
  }
  .fx p{
    font-size: 0.12rem;
    color: #666666;
    text-align: center;
    white-space: nowrap;
    padding-top: 0.06rem;
    margin-left: -0.04rem;
  }
  .commendInput{
    width: 3.7rem;
    height: 0.74rem;
    line-height: 0.74rem;
    background: #f1f1f1;
    color: #aaaaaa;
    text-indent: 0.25rem;
    border-radius: 0.05rem;
    margin-right: 0.635rem;
    font-size: 0.26rem;
  }
  footer{
    height: 1.06rem;
    display: flex;
    padding: 0 0.32rem;
    padding-top: 0.16rem;
    border-top: 0.02rem solid #eeeeee;
  }
  footer img{
    width: 0.43rem;
  }
  .secondCommentTime{
    height: 0.33rem;
    line-height: 0.33rem;
    color: #999;
    font-size: 0.22rem;
  }
  .commentTime{
    margin-bottom: 0.15rem;
  }
  .commentTime span:first-child{
    height: 0.33rem;
    line-height: 0.33rem;
    color: #999;
    font-size: 0.22rem;
  }
  .commentTime span:last-child{
    height: 0.33rem;
    line-height: 0.33rem;
    color: #1B6BB4;
    font-size: 0.28rem;
  }
  .userMessage{
    margin-bottom: 0.1rem;
    color: #333;
    font-size: 0.28rem;
    line-height: 0.42rem;
  }
  .commenNumber span{
    color: #999;
    font-size: 0.24rem;
    line-height: 0.33rem;
  }
  .commenNumber img{
    width: 0.35rem;
  }
  .userName span:first-child{
    color: #333;
    font-size: 0.28rem;
    font-family: PingFangSC-Medium;
    font-weight: 1000;
    padding-right: 0.1rem;
  }
  .userName span:last-child{
    color: #666;
    font-size: 0.24rem;
    line-height: 0.33rem;
  }
  .userBox{
    height: 0.33rem;
    line-height: 0.33rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 0.1rem;
  }
  .imgBox{
    float: left;
    width: 20%;
  }
  .imgBox img{
    width: 0.84rem;
    border-radius:50%;
  }
  .rightBox{
    float: right;
    width: 80%;
  }
  .mobileDocDetail{
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  }
  main{
  flex: 1;
  overflow-y: auto;
  }
  .detailTitle{
    border-bottom: 0.01rem solid #eeeeee;
    padding: 0 0.28rem;
  }
  .detailMessage{
    padding: 0 0.28rem;
  }
  .detailTitle h1{
    height: 0.56rem;
    line-height: 0.56rem;
    font-size: 0.4rem;
    margin: 0.3rem 0;
    text-align: left;
    color: #333333;
    font-family: PingFangSC-Medium;
  }
  .titieFooter{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0.2rem 0;
  }
  .titieFooter p:first-child{
    font-size: 0.24rem;
    height: 33px;
    line-height: 33px;
    font-family: PingFangSC-Regular;
    color: #999999;
  }
  .titieFooter p:last-child{
    font-size: 0.24rem;
    height: 33px;
    line-height: 33px;
    font-family: PingFangSC-Regular;
    color: #1B6BB4;
  }
  .titieFooter p:last-child img{
    width: 0.23rem;
  }
  .title{
  height: 0.88rem;
  font-size: 0.36rem;
  line-height: 0.88rem;
  text-align: center;
  border-bottom: 0.01rem solid #eeeeee;
  }
  .title i{
  float: left;
  font-size: 0.52rem;
  padding-left: 0.22rem;
  padding-top: 0.16rem;
  }
  .title i{
  float: left;
  font-size: 0.52rem;
  padding-left: 0.22rem;
  padding-top: 0.16rem;
  }
  .title span{
  margin-left: -0.72rem;
  color: #333333;
  letter-spacing: 0;
  font-family: PingFangSC-Medium;
  font-weight: 600;
  }
  .readCounts{
    height: 0.33rem;
    line-height: 0.33rem;
    font-size: 0.24rem;
    color: #999;
    text-align: right;
    margin: 0.3rem 0;
  }
  .messageContents{
    padding-top: 0.24rem;
    font-size: 0.3rem;
    line-height: 0.48rem;
  }
  .commentBox{
    padding: 0 0.28rem;
  }
  .commentTitle{
    height: 0.5rem;
    line-height: 0.5rem;
    font-size: 0.36rem;
    margin: 0.2rem 0;
  }
  .commentTitle span{
    display: inline-block;
    height: 0.46rem;
    border-left: 0.06rem solid #1B6BB4;
    padding-left: 0.2rem;
    color: #000;
  }
</style>>
